import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 300;
  display: flex;
  justify-content: flex-end;
`;

export const Drawer = styled.div`
  width: 400px;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.22s ease;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.12);
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

export const DrawerTitle = styled.h2`
  font-size: 18px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.02em;
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background-color: #f5f5f5;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  transition: background-color 0.15s;

  &:hover { background-color: #ebebeb; }
`;

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DrawerFooter = styled.div`
  padding: 20px 28px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 10px;
  flex-shrink: 0;
`;

export const Field = styled.div``;

export const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  letter-spacing: 0.02em;
  margin-bottom: 8px;
`;

export const Required = styled.span`
  color: #fc324a;
  margin-left: 2px;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  height: 44px;
  padding: 0 12px;
  border: 1.5px solid ${({ hasError }) => (hasError ? "#fc324a" : "#e8e8e8")};
  border-radius: 10px;
  font-size: 14px;
  color: #111;
  background-color: #fafafa;
  transition: border-color 0.15s;

  &::placeholder { color: #bbb; }
  &:focus {
    outline: none;
    border-color: ${({ hasError }) => (hasError ? "#fc324a" : "#1fbc70")};
    background-color: #fff;
  }
`;

export const FieldError = styled.p`
  font-size: 12px;
  color: #fc324a;
  margin-top: 5px;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 48px;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #666;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #f5f5f5; }
`;

export const SubmitButton = styled.button`
  flex: 2;
  height: 48px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  background-color: #1fbc70;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #18a860; }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
